// GENERATED from packages/design-system/tokens/thesis3.tokens.json — do not edit. Run `npm run tokens:build`.
export const tokens = {
  "$description": "Thesis3 brand tokens — THE single source of truth. The MUI theme (packages/design-system) and the Keycloak theme CSS (infrastructure/keycloak/themes/platform) are both GENERATED from this file via `npm run tokens:build`. Never hand-copy a hex value anywhere.",
  "color": {
    "ink": "#0D0F1A",
    "pink": "#FF2D78",
    "gold": "#F7C500",
    "teal": "#00D4B8",
    "cream": "#F7F4EF",
    "white": "#FFFFFF",
    "background": "#FFFFFF",
    "surface": "#F7F4EF",
    "surfaceAlt": "#EFEAE1",
    "text": "#0D0F1A",
    "textMuted": "#6B6675",
    "border": "#E2DCD0",
    "success": "#1B8A5A",
    "warning": "#B7791F",
    "danger": "#D93A2B",
    "focusRing": "#00D4B8",
    "pinkHover": "#E22368",
    "pinkActive": "#C81C5C",
    "inkHover": "#1A1F33"
  },
  "dark": {
    "background": "#0D0F1A",
    "surface": "#151A28",
    "surfaceAlt": "#1C2233",
    "text": "#F7F4EF",
    "textMuted": "#9A94A6",
    "border": "#2A3145"
  },
  "font": {
    "display": "\"Arial Black\", \"Arial Bold\", Arial, system-ui, sans-serif",
    "body": "Arial, Helvetica, system-ui, sans-serif",
    "mono": "\"Courier New\", ui-monospace, monospace"
  },
  "radius": {
    "base": 8,
    "small": 4,
    "large": 14,
    "pill": 999
  },
  "spacing": {
    "base": 4
  },
  "shadow": {
    "card": "0 2px 10px rgba(13, 15, 26, 0.08)",
    "raised": "0 8px 30px rgba(13, 15, 26, 0.16)"
  },
  "brand": {
    "name": "thesis3",
    "wordmark": "thesis3",
    "tagline": "BUILT ON PROOF. NOT PROMISE.",
    "productName": "Underwriting Workbench"
  },
  "workbench": {
    "$description": "The workbench chrome palette, emitted as the --t3a-* custom properties in apps/workbench/src/tokens.generated.css. Hand-copied into admin.css until Wave 1 R7; the *Text entries exist because the soft-background chips need a darker ink than the fill colour to clear 4.5:1 (WCAG AA) - amber and green were the two that failed.",
    "bg": "#F7F4EF",
    "panel": "#FFFFFF",
    "ink": "#0D0F1A",
    "muted": "#5C6070",
    "line": "#E6E1D6",
    "pink": "#FF2D78",
    "pinkDark": "#C41E5B",
    "pinkSoft": "#FFE6F0",
    "dark": "#0D0F1A",
    "dark2": "#1A1F35",
    "sideInk": "#CFC9DB",
    "sideInkStrong": "#FFFFFF",
    "sideInkMuted": "#8B87A0",
    "navActiveBg": "#42162F",
    "navActiveInk": "#FF77A7",
    "green": "#0E9F6E",
    "greenSoft": "#E6F6F0",
    "greenText": "#0B7A55",
    "amber": "#D4A000",
    "amberSoft": "#FAF3D6",
    "amberText": "#8A6100",
    "red": "#DC2626",
    "redSoft": "#FDEAEA",
    "redText": "#B3251C",
    "blue": "#0A8FA3",
    "blueSoft": "#DFF6F2",
    "purple": "#7C3AED",
    "purpleSoft": "#F1EAFD",
    "surfaceAlt": "#FAF8F6",
    "surfaceAlt2": "#F0EEEA",
    "surfaceAlt3": "#F4F1EC",
    "surfaceAlt4": "#F1EEE9",
    "surfaceAlt5": "#EEECE6",
    "surfaceAlt6": "#EAE6E0",
    "dangerWash": "#FDF7F7",
    "infoSoft": "#E8F1FD",
    "infoInk": "#2563EB",
    "purpleWash": "#F1EBFB"
  },
  "focus": {
    "$description": "One focus ring for every interactive element (Wave 1 R7). Never removed, never restyled per component.",
    "width": 2,
    "offset": 2,
    "color": "#00D4B8"
  },
  "type": {
    "$description": "Wave 1 R7 raises the floor: base 14, nothing below 12, micro-labels 11 in normal case rather than uppercase.",
    "base": 14,
    "small": 12,
    "micro": 11,
    "lineHeight": 1.45
  },
  "chart": {
    "$description": "Categorical series colours and the three portfolio-health states, moved out of dashboardChrome.ts in Wave 1 R7. Series order is fixed: a line keeps its colour between renders and between charts, which is what makes two charts on one page comparable.",
    "series": [
      "#E8446D",
      "#2F8F9D",
      "#2FA279",
      "#C9971C",
      "#7C4BD6",
      "#1D2440"
    ],
    "healthy": "#2E9E6B",
    "watch": "#C9971C",
    "constrained": "#C0392B"
  },
  "chip": {
    "$description": "Chip fill/ink pairs. Each ink is chosen to clear 4.5:1 on its own fill, which is why the ink is never the same value as the corresponding brand colour - #6C3FF0 on #EEE8FB passes where the brand purple would not.",
    "lavenderBg": "#EEE8FB",
    "lavenderInk": "#6C3FF0",
    "greenBg": "#DFF3E9",
    "pinkBg": "#FDE7F0"
  }
} as const;

export type Tokens = typeof tokens;
